// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!../../../../css-loader/dist/cjs.js??clonedRuleSet-29.use[1]!../../../../postcss-loader/dist/cjs.js??clonedRuleSet-29.use[2]!../../../../postcss-loader/dist/cjs.js??clonedRuleSet-29.use[3]!../../../../sass-loader/dist/cjs.js??clonedRuleSet-29.use[4]!./VAlert.sass");
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add CSS to Shadow Root
var add = require("!../../../../vue-style-loader/lib/addStylesShadow.js").default
module.exports.__inject__ = function (shadowRoot) {
  add("db7853e6", content, shadowRoot)
};